import React, { useState, useEffect, useId } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import "./createques.css";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import SelectedDropdownValues from "./SelectedDropdownValues";
import { fetchClassData } from "../../../Redux/StudentRegistration/classSlice";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import NotesIcon from "./../../../Assets/Images/CommanImages/grommet-icons_notes.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorIcon from "./../../../Assets/Images/CommanImages/Error.png";
import SuccessImg from "./../../../Assets/Images/CommanImages/Informative.png";
import MultiSeledDropdown from "../MultiDropdown/MultiSeledDropdown";
import MultiProgress from "../MultiProgressBar/MultiProgress";
import { fetchScopeData } from "../../../Redux/Scope/ScopeSlice";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import FacultySelector from "../MultipleAssignCreator/FacultySelector";
import MultiSelectSearchDropdown from "../SearchDropDown/MultiSelectSearchDropdown";

function CreateQuesPaper({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setNoTimeSet,
}) {
  const [questionPaperType, setQuestionPaperType] = useState(null);
  const [selectedtestSeriesId, setSelectedTestSeriesID] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { coursesdata = [] } = useSelector((state) => state.course) || {};
  const { classData = [] } = useSelector((state) => state.classname) || {};
  const { scopeData = [] } = useSelector((state) => state.scopes) || {};
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedClass, setSelectedClass] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const [chapterData, setChapterData] = useState({});
  const [checkedSubjects, setCheckedSubjects] = useState({});
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenSubject, setIsOpenSubject] = useState(true);
  const [totalQuestionCount, setTotalQuestionCount] = useState(0);
  const [QuestionTypeId, setQuestionTypeID] = useState(null);
  const [selectedChapters, setSelectedChapters] = useState({});
  // State to hold each subject's difficulty distribution from MultiProgress
  const [difficultyDistributions, setDifficultyDistributions] = useState({});
  const [selectScope, setSelectedScope] = useState(null);
  const [openNotes, setOpenNotes] = useState({});
  const [batchData, setBatchData] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]); // State selection
  const [stateData, setStateData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedZone, setSelectedZone] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [selectedFaculties, setSelectedFaculties] = useState([]);
  const [selectedAssigReviewerFaculties, setSelectedAssigReviewerFaculties] =
    useState([]);
  const [selectedCreatorsBySubject, setSelectedCreatorsBySubject] = useState(
    {}
  );
  const [selectedReviewersBySubject, setSelectedReviewersBySubject] = useState(
    {}
  );
  const [dropdownKey, setDropdownKey] = useState(0);
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const userId = dataClient && dataClient.client_schema_name[6][0].user_id;
  const [specialInstructions, setSpecialInstructions] = useState({});
  const [patternsData, setPatternsData] = useState([]);
  const [selectedPatternDetails, setSelectedPatternDetails] = useState(null);
  const [selectedPattern, setSelectedPattern] = useState(null);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [createdQuesPaperId, setCreatedQuesPaperId] = useState(null);
  const accessToken = localStorage.getItem("other");
  const [patternNameError, setPatternNameError] = useState(false);
  const [patternDescError, setPatternDescError] = useState(false);

  // FOR STUDENT GROUP
  const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
  const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
  const [allStudentGroups, setAllStudentGroups] = useState([]);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      client_branch_id: clientBranchId,
      created_by: userName,
    }));
  }, [clientBranchId, userName]);

  const [showPatternPopup, setShowPatternPopup] = useState(false);
  const [patternName, setPatternName] = useState("");
  const [patternDesc, setPatternDesc] = useState("");

  useEffect(() => {
    dispatch(fetchClassData());
    dispatch(fetchCourseData());
    dispatch(fetchScopeData());
  }, [dispatch]);

  useEffect(() => {
    if (selectedCourse) {
      fetch(
        `${FULL_API_BASE_URL}/get-subjects-by-course/?course_id=${selectedCourse}`
      )
        .then((response) => response.json())
        .then((data) => setSubjects(data || []))
        .catch((error) => console.error("Error fetching subjects:", error));
    } else {
      setSubjects([]);
    }
  }, [selectedCourse]);

  const handleSubjectCheck = (subjectId) => {
    setCheckedSubjects((prev) => {
      const isChecked = !prev[subjectId];
      const chapters = chapterData[subjectId] || [];

      if (isChecked) {
        setSelectedChapters((prevChapters) => ({
          ...prevChapters,
          [subjectId]: chapters.map((ch) => ch.chapter_id),
        }));

        setFormData((prevFormData) => {
          const existingSubject = prevFormData.subjects.find(
            (s) => s.subject_id === subjectId
          );

          let easy = 0,
            medium = 0,
            tough = 0;

          if (questionPaperType === 2) {
            // ✅ Test Series → reuse distribution already set from API
            easy = difficultyDistributions[subjectId]?.firstSegment || 0;
            medium = difficultyDistributions[subjectId]?.secondSegment || 0;
            tough = difficultyDistributions[subjectId]?.calculatedValue || 0;
          } else {
            // ✅ DPP → reset to 0 (fresh entry)
            easy = 0;
            medium = 0;
            tough = 0;
          }

          return {
            ...prevFormData,
            subjects: [
              ...prevFormData.subjects.filter(
                (s) => s.subject_id !== subjectId
              ),
              {
                subject_id: subjectId,
                easy,
                medium,
                tough,
                special_inst: existingSubject?.special_inst || "",
                chapters: chapters.map((ch) => ({ chapter_id: ch.chapter_id })),
              },
            ],
          };
        });
      } else {
        setSelectedChapters((prevChapters) => ({
          ...prevChapters,
          [subjectId]: [],
        }));

        setExpandedSubjects((prev) => ({
          ...prev,
          [subjectId]: false,
        }));

        setFormData((prevFormData) => ({
          ...prevFormData,
          subjects: prevFormData.subjects.filter(
            (s) => s.subject_id !== subjectId
          ),
        }));
      }

      return { ...prev, [subjectId]: isChecked };
    });

    if (!chapterData[subjectId]) {
      fetch(
        `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${subjectId}`
      )
        .then((response) => response.json())
        .then((data) => {
          setChapterData((prev) => ({ ...prev, [subjectId]: data }));
          setSelectedChapters((prevChapters) => ({
            ...prevChapters,
            [subjectId]: data.map((ch) => ch.chapter_id),
          }));
        })
        .catch((error) => console.error("Error fetching chapters:", error));
    }
  };

  const toggleExpandSubject = (subjectId) => {
    // if (checkedSubjects[subjectId] && !selectedtestSeriesId) {
    if (checkedSubjects[subjectId]) {
      setExpandedSubjects((prev) => ({
        ...prev,
        [subjectId]: !prev[subjectId],
      }));

      if (!chapterData[subjectId]) {
        fetch(
          `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${subjectId}`
        )
          .then((response) => response.json())
          .then((data) => {
            setChapterData((prev) => ({ ...prev, [subjectId]: data }));
            setSelectedChapters((prevChapters) => ({
              ...prevChapters,
              [subjectId]: data.map((ch) => ch.chapter_id),
            }));
          })
          .catch((error) => console.error("Error fetching chapters:", error));
      }
    }
  };

  const syncSubjectFromChapters = (subjectId, nextChapterIds) => {
    // Auto-check subject if any chapter, uncheck if none
    setCheckedSubjects((prev) => ({
      ...prev,
      [subjectId]: nextChapterIds.length > 0,
    }));
    setFormData((prev) => {
      const filtered = prev.subjects.filter((s) => s.subject_id !== subjectId);

      if (nextChapterIds.length === 0) {
        // Remove subject if no chapters
        return { ...prev, subjects: filtered };
      }
      const existing = prev.subjects.find((s) => s.subject_id === subjectId);
      const dist = difficultyDistributions[subjectId] || {};
      return {
        ...prev,
        subjects: [
          ...filtered,
          {
            subject_id: subjectId,
            easy: existing?.easy ?? dist.firstSegment ?? 0,
            medium: existing?.medium ?? dist.secondSegment ?? 0,
            tough: existing?.tough ?? dist.calculatedValue ?? 0,
            special_inst:
              existing?.special_inst ?? specialInstructions[subjectId] ?? "",
            chapters: nextChapterIds.map((id) => ({ chapter_id: id })),
          },
        ],
      };
    });
  };

  const handleChapterCheck = (subjectId, chapterId) => {
    setSelectedChapters((prev) => {
      const current = prev[subjectId] || [];
      const next = current.includes(chapterId)
        ? current.filter((id) => id !== chapterId)
        : [...current, chapterId];
      syncSubjectFromChapters(subjectId, next);

      return { ...prev, [subjectId]: next };
    });
  };

  const handleSelectAllChapters = (subjectId) => {
    const total = chapterData[subjectId]?.length || 0;
    const allSelected = (selectedChapters[subjectId]?.length || 0) === total;

    const next = allSelected
      ? [] // clearing all
      : chapterData[subjectId].map((ch) => ch.chapter_id);

    setSelectedChapters((prev) => ({ ...prev, [subjectId]: next }));

    // 🔑 Sync subject checkbox automatically
    syncSubjectFromChapters(subjectId, next);
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const toggleAccordionSubjects = () => {
    setIsOpenSubject(!isOpenSubject);
  };

  const [manuallyUpdatedSubjects, setManuallyUpdatedSubjects] = useState({});

  const handleQuestionCountChange = (subjectId, value) => {
    if (/^\d*$/.test(value)) {
      const parsedValue = parseInt(value || 0, 10);

      setManuallyUpdatedSubjects((prev) => ({
        ...prev,
        [subjectId]: true,
      }));

      setSubjects((prevSubjects) =>
        prevSubjects.map((subject) =>
          subject.subject_id === subjectId
            ? { ...subject, questionCount: parsedValue }
            : subject
        )
      );

      // Distribute difficulty evenly
      const easy = Math.floor(parsedValue / 3);
      const medium = Math.floor(parsedValue / 3);
      const tough = parsedValue - (easy + medium);

      const newDistribution = {
        firstSegment: easy,
        secondSegment: medium,
        calculatedValue: tough,
      };

      setDifficultyDistributions((prev) => ({
        ...prev,
        [subjectId]: newDistribution,
      }));

      setFormData((prevFormData) => {
        const updatedSubjects = prevFormData.subjects.map((subject) => {
          if (subject.subject_id === subjectId) {
            return {
              ...subject,
              easy,
              medium,
              tough,
            };
          }
          return subject;
        });

        return {
          ...prevFormData,
          subjects: updatedSubjects,
        };
      });

      // Update total
      const newTotal = subjects.reduce((acc, subject) => {
        const count =
          subject.subject_id === subjectId
            ? parsedValue
            : parseInt(subject.questionCount || 0, 10);
        return acc + count;
      }, 0);
      setTotalQuestionCount(newTotal);
    }
  };

  const handleSliderChange = (subjectId, values) => {
    setDifficultyDistributions((prev) => ({
      ...prev,
      [subjectId]: values,
    }));

    // 🟢 Also update formData.subjects here
    setFormData((prevFormData) => {
      const updatedSubjects = prevFormData.subjects.map((subject) => {
        if (subject.subject_id === subjectId) {
          return {
            ...subject,
            easy: values.firstSegment || 0,
            medium: values.secondSegment || 0,
            tough: values.calculatedValue || 0,
          };
        }
        return subject;
      });

      return {
        ...prevFormData,
        subjects: updatedSubjects,
      };
    });
  };

  const toggleNotesInput = (subjectId) => {
    if (!checkedSubjects[subjectId]) return; // Prevent opening if subject is not selected
    setOpenNotes((prev) => ({
      ...prev,
      [subjectId]: !prev[subjectId],
    }));

    // Ensure there's an entry for the special instruction
    if (!specialInstructions[subjectId]) {
      setSpecialInstructions((prev) => ({
        ...prev,
        [subjectId]: "",
      }));
    }
  };

  const [formData, setFormData] = useState({
    ques_paper_name: "",
    description: "",
    ques_paper_type: QuestionTypeId,
    course_id: selectedCourse,
    ques_paper_series: selectedPattern,
    due_date: "",
    ques_paper_scope_id: selectScope,
    test_series_id: selectedtestSeriesId,
    scope_ref_id: null,
    client_branch_id: clientBranchId,
    created_by: userName,
    status: 1,
    guidelines: "",
    // courses: [{ course_id: selectedCourse }],
    classes: selectedClass,
    subjects: [
      {
        subject_id: 0,
        easy: 0,
        medium: 0,
        tough: 0,
        special_inst: "",
        chapters: [],
      },
    ],
    assign_creators: [
      {
        subject_id: 0,
        user_ids: selectedFaculties.map((faculty) => faculty.user_id),
      },
    ],
    assign_reviewers: [
      { subject_id: 0, user_id: selectedAssigReviewerFaculties.user_id },
    ],
    student_group_id_list: [],
  });

  // helper to ensure chapters are fetched
  const ensureAllChaptersFetched = async () => {
    const promises = Object.keys(checkedSubjects)
      .filter((sid) => checkedSubjects[sid])
      .filter((sid) => !chapterData[sid]) // not fetched yet
      .map(async (sid) => {
        const res = await fetch(
          `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${sid}`
        );
        const data = await res.json();
        setChapterData((prev) => ({ ...prev, [sid]: data || [] }));
        setSelectedChapters((prev) => ({
          ...prev,
          [sid]: (data || []).map((c) => c.chapter_id),
        }));
      });

    await Promise.all(promises);
  };

  const handleSubmit = async () => {
    let errorMessage = "";
    let warningMessage = "";

    if (!formData.course_id) {
      errorMessage = "Course selection is required.";
    } else if (!formData.ques_paper_type) {
      errorMessage = "Question Paper Type is required.";
    } else if (formData.ques_paper_type === 2 && !formData.test_series_id) {
      errorMessage = "Test Series is mandatory when Test type is selected.";
    } else if (!selectedClass || selectedClass.length === 0) {
      errorMessage = "At least one class must be selected.";
    } else if (!formData.ques_paper_name) {
      errorMessage = "Test Name is required.";
    } else if (!formData.due_date) {
      errorMessage = "Due Date is required.";
    }
    // else if (formData.ques_paper_scope_id && (
    //   (formData.scope_ref_id === null || formData.scope_ref_id.length === 0)
    // )) {
    //   errorMessage = "At least one Scope Reference must be selected.";
    // }
    else if (
      formData.ques_paper_scope_id &&
      formData.ques_paper_scope_id !== 9 && // Skip for Group scope
      (formData.scope_ref_id === null || formData.scope_ref_id.length === 0)
    ) {
      errorMessage = "At least one Scope Reference must be selected.";
    } else if (!formData.description) {
      errorMessage = "Description is required.";
    } else if (
      formData.ques_paper_type === 1 &&
      (!formData.ques_paper_scope_id ||
        formData.scope_ref_id === null ||
        formData.scope_ref_id.length === 0) &&
      (!selectedStudentGroup || selectedStudentGroup.length === 0)
    ) {
      errorMessage = "For DPP, either Scope or Student Group must be selected.";
    } else {
      const dueDate = new Date(formData.due_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      dueDate.setHours(0, 0, 0, 0);

      if (isNaN(dueDate.getTime())) {
        errorMessage = "Please enter a valid due date.";
      } else if (dueDate < today) {
        errorMessage = "Test Date cannot be in the past.";
      }
    }

    //  Ensure at least one subject is selected
    const selectedSubjects = subjects.filter(
      (subject) => checkedSubjects[subject.subject_id]
    );
    if (!errorMessage && selectedSubjects.length === 0) {
      errorMessage = "At least one subject must be selected.";
    }

    //  Ensure question count is not zero for any selected subject
    const hasZeroQuestionCount = selectedSubjects.some(
      (subject) => (parseInt(subject.questionCount, 10) || 0) === 0
    );
    if (!errorMessage && hasZeroQuestionCount) {
      errorMessage = "Question count cannot be zero for any selected subject.";
    }

    if (!errorMessage && formData.ques_paper_type === 1) {
      // Assuming 1 = "DPP"
      const hasExcessiveDPP = selectedSubjects.some(
        (subject) => (parseInt(subject.questionCount, 10) || 0) > 50
      );

      if (hasExcessiveDPP) {
        warningMessage +=
          (warningMessage ? "\n" : "") +
          "DPP should not have more than 50 questions per subject.";
      }
    }
    const assignCreators = selectedSubjects.map((subject) => ({
      subject_id: subject.subject_id,
      user_ids: (selectedCreatorsBySubject[subject.subject_id] || []).map(
        (faculty) => faculty.user_id
      ),
    }));

    const hasSubjectWithoutCreator = assignCreators.some(
      (subject) => subject.user_ids.length === 0
    );
    if (!errorMessage && hasSubjectWithoutCreator) {
      errorMessage =
        "Each selected subject must have at least one assigned creator.";
    }

    const assignReviewers = selectedSubjects
      .map((subject) => {
        const reviewers = selectedReviewersBySubject[subject.subject_id] || [];
        if (reviewers.length > 0) {
          return {
            subject_id: subject.subject_id,
            user_id: reviewers[0].user_id,
          };
        }
        return null; // skip if no reviewer
      })
      .filter((rev) => rev !== null);

    const finalAssignReviewers = assignReviewers;
    const allDifficultQuestions = selectedSubjects.every((subject) => {
      const difficulty = difficultyDistributions[subject.subject_id] || {};
      return (
        (difficulty.calculatedValue || 0) > 0 &&
        (difficulty.firstSegment || 0) === 0 &&
        (difficulty.secondSegment || 0) === 0
      );
    });

    if (allDifficultQuestions) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Warning: All selected questions are difficult. Consider adjusting
              the difficulty distribution.
            </span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      // Wait 2 seconds before proceeding
      await new Promise((resolve) => setTimeout(resolve, 2000));
    }
    //  Show error message if any
    if (errorMessage) {
      console.error("Validation Error:", errorMessage);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{errorMessage}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      return;
    }

    //  Show warning message if any
    if (warningMessage) {
      console.warn("Warning:", warningMessage);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{warningMessage}</span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      return;
    }

    try {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Processing request, please wait...</span>
          </div>
        </div>
      );
      setActiveImg(null);

      await ensureAllChaptersFetched();
      //  Prepare final payload
      const updatedFormData = {
        ...formData,
        subjects: selectedSubjects.map((subject) => ({
          subject_id: subject.subject_id,
          easy: difficultyDistributions[subject.subject_id]?.firstSegment || 0,
          medium:
            difficultyDistributions[subject.subject_id]?.secondSegment || 0,
          tough:
            difficultyDistributions[subject.subject_id]?.calculatedValue || 0,
          special_inst: specialInstructions[subject.subject_id] || "",
          chapters: (selectedChapters[subject.subject_id] || []).map(
            (chapterId) => ({
              chapter_id: chapterId,
            })
          ),
        })),
        assign_creators: assignCreators,
        assign_reviewers: finalAssignReviewers,
        student_group_id_list: selectedStudentGroup,
      };

      const response = await fetch(
        `${FULL_API_BASE_URL}/curate-question-paper/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(updatedFormData),
        }
      );
      const responseData = await response.json();
      const createdPaperId = responseData?.data?.ques_paper_id;

      setCreatedQuesPaperId(createdPaperId);

      if (responseData.status === 409) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{responseData.message}</span>
            </div>
          </div>
        );
        setActiveImg(ErrorIcon);
        return;
      }

      if (!response.ok) {
        throw new Error(
          responseData.message || `HTTP error! Status: ${response.status}`
        );
      }
      // try {
      //   const checkRes = await fetch(
      //     `${FULL_API_BASE_URL}/check-duplicate-layout/?client_branch_id=${clientBranchId}&username=${userName}&ques_ppr_id=${createdPaperId}`,
      //     {
      //       method: "POST",
      //       headers: {
      //         Authorization: `Bearer ${accessToken}`,
      //         "Content-Type": "application/json",
      //       },
      //     }
      //   );

      //   const checkData = await checkRes.json();

      //   if (
      //     checkData.status === 200 &&
      //     checkData.message ===
      //     "No Duplicate pattern found for current ques_paper_id."
      //   ) {
      //     setNoTimeSet(true);
      //     // setIsMessageBoxVisible(true);
      //     setMessageBox(
      //       <div className="Container-messageBOX">
      //         <div className="messagebox-insider1">
      //           <div className="loader-tc"></div>
      //           <span>
      //             Question paper created successfully. Do you want to save this
      //             as a pattern?
      //           </span>
      //         </div>
      //         <div
      //           className="messagebox-insider2"
      //           style={{ display: "flex", gap: "10px", marginTop: "10px" }}
      //         >
      //           <button
      //             className="messagebox-cancel-btn-ok"
      //             onClick={() => {
      //               setIsMessageBoxVisible(false);
      //               setShowPatternPopup(true);
      //             }}
      //           >
      //             YES
      //           </button>
      //           <button
      //             className="messagebox-cancel-btn-ok"
      //             onClick={() => {
      //               setIsMessageBoxVisible(false);
      //               setNoTimeSet(false);
      //               // setTimeout(() => {
      //               //   window.location.reload();
      //               // }, 1000);
      //               setTimeout(() => {
      //                 navigate("/assignor_dashboard_details"); // 👈 change this to your actual route
      //               }, 500);
      //             }}
      //           >
      //             NO
      //           </button>
      //         </div>
      //       </div>
      //     );
      //     setActiveImg(InterogativeImg);
      //     setIsMessageBoxVisible(true);
      //   } else if (
      //     checkData.status === 404 &&
      //     checkData.message === "Duplicate pattern found"
      //   ) {
      //     setMessageBox(
      //       <div className="Container-messageBOX">
      //         <div className="messagebox-insider1">
      //           <div className="loader-tc"></div>
      //           <span>
      //             <b>Duplicate pattern found</b>: <b>{checkData.layout_name}</b>
      //             .<br />
      //           </span>
      //         </div>
      //       </div>
      //     );
      //     setActiveImg(InterogativeImg);
      //     setIsMessageBoxVisible(true);
      //     setTimeout(() => {
      //       window.location.reload();
      //     }, 2000);
      //   } else {
      //     throw new Error(
      //       checkData.message || "Duplicate pattern or unknown error"
      //     );
      //   }
      // } catch (error) {
      //   console.error("Duplicate check failed:", error);
      //   setMessageBox(
      //     <div className="Container-messageBOX">
      //       <div className="messagebox-insider1">
      //         <div className="loader-tc"></div>
      //         <span>
      //           {error.message ||
      //             "An error occurred while checking duplicate pattern."}
      //         </span>
      //       </div>
      //     </div>
      //   );
      //   setActiveImg(InterogativeImg);
      // }
      setNoTimeSet(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Question paper created successfully. Do you want to save this as a
              pattern?
            </span>
          </div>
          <div
            className="messagebox-insider2"
            style={{ display: "flex", gap: "10px", marginTop: "10px" }}
          >
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
                setShowPatternPopup(true); // ✅ Only here "Save Pattern" flow starts
              }}
            >
              YES
            </button>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
                setNoTimeSet(false);
                setTimeout(() => {
                  navigate("/assignor_dashboard_details");
                }, 500);
              }}
            >
              NO
            </button>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      setIsMessageBoxVisible(true);
    } catch (error) {
      console.error("Error:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              {error.message ||
                "An unexpected error occurred. Please try again."}
            </span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
    }
  };

  const [patternPopupError, setPatternPopupError] = useState("");

  const handleCreatePattern = async () => {
    const isNameEmpty = !patternName.trim();
    const isDescEmpty = !patternDesc.trim();
    setPatternNameError(isNameEmpty);
    setPatternDescError(isDescEmpty);
    if (isNameEmpty || isDescEmpty) return;
    try {
      const encodedName = encodeURIComponent(patternName);
      const encodedDesc = encodeURIComponent(patternDesc);

      const response = await fetch(
        `${FULL_API_BASE_URL}/check-duplicate-layout/?client_branch_id=${clientBranchId}&username=${userName}&ques_ppr_id=${createdQuesPaperId}&ques_paper_layout_name=${encodedName}&ques_paper_layout_desc=${encodedDesc}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      // 2. Handle duplicate pattern name (both generic and descriptive error)
      // if (
      //   data.status === 404 &&
      //   (data.message === "Duplicate" ||
      //     data.message?.toLowerCase().includes("already exists"))
      // ) {
      //   setPatternPopupError(data.message);
      //   setShowPatternPopup(true);
      //   setNoTimeSet(false);
      //   return;
      // }

      if (data.status === 404 && data.message === "Duplicate pattern found") {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                <b>Duplicate pattern found</b>: <b>{data.layout_name}</b>
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorIcon);
        setShowPatternPopup(true); // keep popup open
        setNoTimeSet(false);
        return;
      }

      if (data.status === 200) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Pattern created successfully!</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setShowPatternPopup(false);

        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
        setTimeout(() => {
          setIsMessageBoxVisible(false);
          navigate("/assignor_dashboard_details");
        }, 1000);
      } else {
        throw new Error(data.message || "Unexpected error");
      }
    } catch (error) {
      console.error("Pattern creation failed:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{error.message || "Failed to create pattern"}</span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
    }
  };

  const handleSpecialInstructionChange = (subjectId, value) => {
    setSpecialInstructions((prev) => ({
      ...prev,
      [subjectId]: value,
    }));
  };

  useEffect(() => {
    const fetchPatterns = async () => {
      if (!selectedCourse) {
        setPatternsData([]);
        setSelectedPatternDetails(null);
        setSelectedSubjects([]);
        return;
      }

      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-pattern-details/?course_id=${selectedCourse}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch pattern details");
        }

        const data = await response.json();

        //  Handle case where no question papers are found
        if (
          !data ||
          !Array.isArray(data.question_papers) ||
          data.question_papers.length === 0
        ) {
          // console.warn("No Question Papers found for this course.");
          setPatternsData([]);
          setSelectedPatternDetails(null);
          setSelectedSubjects([]);
          return;
        }

        //  Process valid pattern data
        const formattedPatterns = data.question_papers.map((pattern) => ({
          id: pattern.ques_paper_layout.ques_paper_layout_id,
          label: `${pattern.ques_paper_layout.ques_paper_layout_name} - ${pattern.ques_paper_layout.ques_paper_layout_desc}`,
          details: pattern.ques_paper_details,
          subjects: pattern.subjects || [],
          // creators: pattern.assigned_creators || [],
          // reviewers: pattern.reviewers || [],
        }));

        setPatternsData(formattedPatterns);
        setSelectedPatternDetails(formattedPatterns[0]?.details || null);
        setSelectedSubjects(formattedPatterns[0]?.subjects || []);
      } catch (error) {
        // console.error("Error fetching pattern data:", error);
        setPatternsData([]); // Ensure state is cleared on error
        setSelectedPatternDetails(null);
        setSelectedSubjects([]);
      }
    };

    fetchPatterns();
  }, [selectedCourse, accessToken]);

  useEffect(() => {
    const fetchScopeDetails = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-scopes-details-all/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (data.status === 200) {
          const apiData = data.data;

          // Extract unique values ensuring correct structure
          const uniqueBatches = apiData.reduce((acc, item) => {
            if (!acc.some((batch) => batch.id === item.batch_id)) {
              acc.push({
                label: `${item.batch_name} / ${item.course_name} / ${item.class_name}`,
                id: item.batch_id,
                course_id: item.course_id,
                class_id: item.class_id,
              });
            }
            return acc;
          }, []);

          const uniqueBranch = apiData.reduce((acc, item) => {
            if (!acc.some((branch) => branch.id === item.branch_id)) {
              acc.push({
                label: `${item.branch_name} / ${item.branch_code} / ${item.zone_code}`,
                id: item.branch_id,
              });
            }
            return acc;
          }, []);

          const uniqueZone = apiData.reduce((acc, item) => {
            if (!acc.some((zone) => zone.id === item.city_zone_id)) {
              acc.push({
                label: `${item.zone_name} / ${item.city_name}`,
                id: item.city_zone_id,
              });
            }
            return acc;
          }, []);

          const uniqueCities = apiData.reduce((acc, item) => {
            if (!acc.some((city) => city.id === item.city_id)) {
              acc.push({
                label: `${item.city_name} / ${item.state_name}`,
                id: item.city_id,
              });
            }
            return acc;
          }, []);

          const uniqueStates = apiData.reduce((acc, item) => {
            if (!acc.some((state) => state.id === item.state_id)) {
              acc.push({
                label: item.state_name,
                id: item.state_id,
              });
            }
            return acc;
          }, []);

          // Set state with unique data
          setBatchData(uniqueBatches);
          setBranchData(uniqueBranch);
          setZoneData(uniqueZone);
          setCityData(uniqueCities);
          setStateData(uniqueStates);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchScopeDetails();
  }, []);

  const [testSeriesOptions, setTestSeriesOptions] = useState([]);

  const [testSeriesData, setTestSeriesData] = useState([]);

  useEffect(() => {
    if (!clientBranchId || !selectedCourse || questionPaperType !== 2) {
      setTestSeriesOptions([]);
      setTestSeriesData([]);
      return;
    }

    const apiUrl = `${FULL_API_BASE_URL}/get-test-series-list-by-branch/?client_branch_id=${clientBranchId}`;

    const fetchTestSeries = async () => {
      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const data = await response.json();

        if (data?.status === 200 && Array.isArray(data.data)) {
          const filtered = data.data.filter(
            (item) => item.course_id === selectedCourse
          );
          const unique = Array.from(
            new Map(filtered.map((ts) => [ts.ts_id, ts])).values()
          );

          const options = unique.map((item) => ({
            id: item.ts_id,
            label: `${item.ts_name} - ${item.ts_desc}`,
          }));

          setTestSeriesOptions(options);
          setTestSeriesData(unique); // store full objects for later
        }
      } catch (err) {
        console.error("Test series fetch failed", err);
      }
    };

    fetchTestSeries();
  }, [clientBranchId, selectedCourse, questionPaperType]);

  // Fetch student groups
  useEffect(() => {
    const fetchStudentGroups = async () => {
      if (!clientBranchId) return;

      try {
        const url = `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`;

        const resp = await fetch(url, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (resp.status === 401 || resp.status === 403) {
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
          return;
        }

        const json = await resp.json();

        if (
          json &&
          (json.status === "200" || json.status === 200) &&
          Array.isArray(json.data)
        ) {
          const options = json.data.map((group) => ({
            id: group.student_group_id,
            label: group.student_group_name,
            session_id: group.session_id || "",
            course_id: group.course_id || "",
          }));
          setStudentGroupsOptions(options);
          setAllStudentGroups(options);
        } else {
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
        }
      } catch (err) {
        setStudentGroupsOptions([]);
        setAllStudentGroups([]);
      }
    };

    fetchStudentGroups();
  }, [clientBranchId, accessToken]);

  // Clear selected student groups when course changes
  useEffect(() => {
    setSelectedStudentGroup([]);
  }, [selectedCourse]);

  // Get filtered student groups based on selected course
  const getFilteredStudentGroups = () => {
    if (!selectedCourse) return studentGroupsOptions;
    return studentGroupsOptions.filter((g) => g.course_id === selectedCourse);
  };

  // Search functionality with course filter
  const searchStudentGroups = (searchKey) => {
    let filtered = allStudentGroups;

    if (selectedCourse) {
      filtered = filtered.filter((g) => g.course_id === selectedCourse);
    }

    if (searchKey && searchKey.trim() !== "") {
      filtered = filtered.filter((g) =>
        g.label.toLowerCase().includes(searchKey.toLowerCase())
      );
    }

    setStudentGroupsOptions(filtered);
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Curate Question Paper</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => {
              navigate(`/assignor_dashboard_details`);
            }}
          >
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSubmit}>
            SAVE
          </button>
        </div>
      </div>
      {/* QUESTION PAPER DETAIL Section */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION PAPER DETAIL</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionSubjects}>
            {isOpenSubject ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenSubject && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del">
              <div className="grid-container-ques-paper-del">
                <div className="item1">
                  {/* RESET WHEN CHANGES THE COURSE */}
                  <DropDown
                    label="Course"
                    selected={selectedCourse}
                    setSelected={(selectedOption) => {
                      // 1. Reset all dependent state
                      setSelectedCourse(selectedOption || null);
                      setSelectedClass([]);
                      setSelectedScope(null);
                      setSelectedBatch([]);
                      setSelectedBranch([]);
                      setSelectedZone([]);
                      setSelectedCities([]);
                      setSelectedStates([]);
                      setSelectedRegion([]);
                      setSubjects([]);
                      setCheckedSubjects({});
                      setExpandedSubjects({});
                      setSelectedChapters({});
                      setSpecialInstructions({});
                      setSelectedTestSeriesID(null);
                      setTestSeriesOptions([]);
                      setTestSeriesData([]);
                      setDifficultyDistributions({});
                      setTotalQuestionCount(0);
                      setSelectedCreatorsBySubject({});
                      setSelectedReviewersBySubject({});
                      setSelectedPattern(null);
                      setSelectedPatternDetails(null);
                      setSelectedSubjects([]);
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        course_id: selectedOption || null,
                        ques_paper_scope_id: null,
                        scope_ref_id: null,
                        classes: [],
                        subjects: [],
                        test_series_id: null,
                        assign_creators: [],
                        assign_reviewers: [],
                      }));

                      // 2. Clear dropdown re-render (if needed)
                      setDropdownKey((prev) => prev + 1);
                    }}
                    options={
                      Array.isArray(coursesdata)
                        ? coursesdata.map((course) => ({
                            label: course.course_name,
                            id: course.course_id,
                          }))
                        : []
                    }
                    isRequired={true}
                  />
                </div>
                <div className="item2">
                  {/* RESET WHEN CHANGES THE TYPE */}
                  <DropDown
                    label="Question Paper Type"
                    selected={questionPaperType}
                    setSelected={(selectedOption) => {
                      setQuestionPaperType(selectedOption);

                      // If DPP selected → reset everything
                      if (selectedOption === 1) {
                        setSelectedTestSeriesID(null);
                        setDropdownKey((prev) => prev + 1); // refresh dropdown

                        // 🔁 Reset everything dependent on Test Series
                        setSelectedClass([]);
                        setSelectedScope(null);
                        setSelectedBatch([]);
                        setSelectedBranch([]);
                        setSelectedZone([]);
                        setSelectedCities([]);
                        setSelectedStates([]);
                        setSelectedRegion([]);
                        // setSubjects([]);
                        setCheckedSubjects({});
                        setExpandedSubjects({});
                        setSelectedChapters({});
                        setSpecialInstructions({});
                        setDifficultyDistributions({});
                        setTotalQuestionCount(0);
                        setSelectedCreatorsBySubject({});
                        setSelectedReviewersBySubject({});
                        setSelectedPattern(null);
                        setSelectedPatternDetails(null);
                        setSelectedSubjects([]);
                        // ✅ Reset subjects → clear out old Test Series counts
                        setSubjects((prev) =>
                          prev.map((s) => ({
                            ...s,
                            questionCount: 0, // reset
                          }))
                        );
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          ques_paper_type: selectedOption,
                          test_series_id: null,
                          ques_paper_scope_id: null,
                          scope_ref_id: null,
                          classes: [],
                          subjects: [],
                          assign_creators: [],
                          assign_reviewers: [],
                        }));
                      } else {
                        // If "Test", just set type in formData
                        setFormData((prev) => ({
                          ...prev,
                          ques_paper_type: selectedOption || null,
                        }));
                      }
                    }}
                    options={[
                      { id: 1, label: "DPP" },
                      { id: 2, label: "Test" },
                    ]}
                    isRequired={true}
                  />
                </div>
                <div className="item2">
                  <DropDown
                    label="Test Series"
                    key={dropdownKey}
                    selected={selectedtestSeriesId}
                    setSelected={(selectedOption) => {
                      setSelectedTestSeriesID(selectedOption);
                      setFormData((prev) => ({
                        ...prev,
                        test_series_id: selectedOption || null,
                      }));
                      // Find the selected test series object
                      const tsObject = testSeriesOptions.find(
                        (ts) => ts.id === selectedOption
                      );

                      // You need the full test series object from API response, so use:
                      const fullTS = testSeriesData.find(
                        (ts) => ts.ts_id === selectedOption
                      );
                      if (!fullTS) return;

                      // ✅ Auto-select Class
                      const classIds = fullTS.class_id_list || [];
                      setSelectedClass(classIds);
                      setFormData((prev) => ({ ...prev, classes: classIds }));

                      // ✅ Auto-select Scope
                      setSelectedScope(fullTS.scope_id);
                      setFormData((prev) => ({
                        ...prev,
                        ques_paper_scope_id: fullTS.scope_id,
                        // scope_ref_id: fullTS.scope_ref_ids || [],
                        scope_ref_id: (fullTS.scope_ref_ids || []).map(
                          (item) => item.id
                        ),
                      }));
                      switch (fullTS.scope_id) {
                        case 1:
                          setSelectedBatch(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 2:
                          setSelectedBranch(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 3:
                          setSelectedZone(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 4:
                          setSelectedCities(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 5:
                          setSelectedStates(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        case 6:
                          setSelectedRegion(
                            (fullTS.scope_ref_ids || []).map((item) => item.id)
                          );
                          break;
                        default:
                          break;
                      }
                      // ✅ Auto-select subjects with Ques Count and checkboxes
                      const checked = {};
                      const questionCounts = {};
                      const difficultyMap = {};
                      const formSubjects = [];
                      let totalCount = 0;
                      const subjectMap = {};
                      (fullTS.subject_section || []).forEach((subj) => {
                        const subjectId = subj.subject_id;
                        if (!subjectMap[subjectId]) {
                          subjectMap[subjectId] = {
                            subject_id: subjectId,
                            // mandatory_ques_cnt: 0,
                            total_question_cnt: 0,
                            ms_desc: subj.ms_desc || "",
                          };
                        }
                        // subjectMap[subjectId].mandatory_ques_cnt += subj.mandatory_ques_cnt || 0;
                        subjectMap[subjectId].total_question_cnt +=
                          subj.total_question_cnt || 0;
                      });

                      Object.values(subjectMap).forEach((subj) => {
                        checked[subj.subject_id] = true;
                        // const count = subj.mandatory_ques_cnt || 0;
                        const count = subj.total_question_cnt || 0;
                        questionCounts[subj.subject_id] = count;

                        const easy = Math.floor(count / 3);
                        const medium = Math.floor(count / 3);
                        const tough = count - (easy + medium);
                        difficultyMap[subj.subject_id] = {
                          firstSegment: easy,
                          secondSegment: medium,
                          calculatedValue: tough,
                        };
                        totalCount += count;

                        formSubjects.push({
                          subject_id: subj.subject_id,
                          easy,
                          medium,
                          tough,
                          special_inst: subj.ms_desc || "",
                          chapters: [],
                        });
                      });

                      setCheckedSubjects(checked);
                      setDifficultyDistributions(difficultyMap);
                      setTotalQuestionCount(totalCount);

                      // Update local subjects state with Ques Count
                      setSubjects((prevSubjects) =>
                        prevSubjects.map((s) => ({
                          ...s,
                          questionCount: questionCounts[s.subject_id] || 0,
                        }))
                      );

                      // Update form data
                      setFormData((prev) => ({
                        ...prev,
                        subjects: formSubjects,
                      }));

                      // ✅ Auto-fetch & select all chapters for every subject in Test Series
                      Object.keys(checked).forEach((subjectId) => {
                        if (chapterData[subjectId]) {
                          // already cached → select all
                          setSelectedChapters((prev) => ({
                            ...prev,
                            [subjectId]: chapterData[subjectId].map(
                              (ch) => ch.chapter_id
                            ),
                          }));
                          return;
                        }

                        fetch(
                          `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${subjectId}`
                        )
                          .then((res) => res.json())
                          .then((data) => {
                            setChapterData((prev) => ({
                              ...prev,
                              [subjectId]: data || [],
                            }));
                            setSelectedChapters((prev) => ({
                              ...prev,
                              [subjectId]: (data || []).map(
                                (ch) => ch.chapter_id
                              ),
                            }));
                          })
                          .catch((e) =>
                            console.error(
                              "Error fetching chapters for subject",
                              subjectId,
                              e
                            )
                          );
                      });
                    }}
                    options={testSeriesOptions}
                    isRequired={true}
                    disabled={questionPaperType === 1}
                  />
                </div>
                <div className="item3">
                  <MultiSeledDropdown
                    label="Class"
                    width="100%"
                    selected={selectedClass}
                    setSelected={(selected) => {
                      setSelectedClass(selected);
                      setFormData({ ...formData, classes: selected });
                    }}
                    options={
                      Array.isArray(classData)
                        ? classData.map((cls) => ({
                            label: cls.class_name,
                            id: cls.class_id,
                          }))
                        : []
                    }
                    showSelectAll={true}
                    isRequired={true}
                    disabled={!!selectedtestSeriesId}
                  />
                </div>
                <div className="item4">
                  <FormInputs
                    label="Question Paper Name"
                    value={formData.ques_paper_name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        ques_paper_name: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div className="item6">
                  <FormInputs
                    label="Due Date"
                    type="datetime-local"
                    value={formData.due_date}
                    onChange={(e) =>
                      setFormData({ ...formData, due_date: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="item7">
                  {/* <SelectedDropdownValues
                    label="Scope"
                    selected={selectScope}
                    setSelected={(selectedOption) => {
                      setSelectedScope(selectedOption || null);
                      setFormData({
                        ...formData,
                        ques_paper_scope_id: selectedOption || null,
                      });
                    }}
                    options={
                      Array.isArray(scopeData)
                        ? scopeData
                          .filter((scope) => {
                            if (questionPaperType === 1) {
                              // Only allow Batch when DPP selected
                              return scope.ques_paper_scope_desc.toLowerCase() === "batch";
                            }
                            return true; // allow all when "Test" selected
                          })
                          .map((scope) => ({
                            label: scope.ques_paper_scope_desc,
                            id: scope.ques_paper_scope_id,
                          }))
                        : []
                    }
                    disabled={!!selectedtestSeriesId}
                  /> */}
                  <SelectedDropdownValues
                    label="Scope"
                    selected={selectScope}
                    setSelected={(selectedOption) => {
                      setSelectedScope(selectedOption || null);
                      setFormData({
                        ...formData,
                        ques_paper_scope_id: selectedOption || null,
                      });
                    }}
                    options={
                      Array.isArray(scopeData)
                        ? scopeData
                            .filter((scope) => {
                              if (questionPaperType === 1) {
                                // ✅ Only allow "Batch" and "Group" when DPP is selected
                                const scopeDesc =
                                  scope.ques_paper_scope_desc.toLowerCase();
                                return (
                                  scopeDesc === "batch" || scopeDesc === "group"
                                );
                              }
                              return true; // Allow all scopes when "Test" is selected
                            })
                            .map((scope) => ({
                              label: scope.ques_paper_scope_desc,
                              id: scope.ques_paper_scope_id,
                            }))
                        : []
                    }
                    disabled={!!selectedtestSeriesId}
                  />
                </div>
                <div className="item8">
                  <MultiSelectSearchDropdown
                    label={
                      selectScope === 1
                        ? "Batch"
                        : selectScope === 2
                        ? "Branch"
                        : selectScope === 3
                        ? "Zone"
                        : selectScope === 4
                        ? "City"
                        : selectScope === 5
                        ? "State"
                        : selectScope === 6
                        ? "Region"
                        : selectScope === 7
                        ? "No Scope"
                        : "Scope Reference"
                    }
                    width="100%"
                    selected={
                      selectScope === 1
                        ? selectedBatch
                        : selectScope === 2
                        ? selectedBranch
                        : selectScope === 3
                        ? selectedZone
                        : selectScope === 4
                        ? selectedCities
                        : selectScope === 5
                        ? selectedStates
                        : selectScope === 6
                        ? selectedRegion
                        : []
                    }
                    setSelected={(selectedOptions) => {
                      if (selectScope === 1) {
                        setSelectedBatch(selectedOptions);
                      } else if (selectScope === 2) {
                        setSelectedBranch(selectedOptions);
                      } else if (selectScope === 3) {
                        setSelectedZone(selectedOptions);
                      } else if (selectScope === 4) {
                        setSelectedCities(selectedOptions);
                      } else if (selectScope === 5) {
                        setSelectedStates(selectedOptions);
                      } else if (selectScope === 6) {
                        setSelectedRegion(selectedOptions);
                      }

                      const validScopeIds =
                        selectedOptions.length > 0
                          ? selectedOptions.map((item) =>
                              typeof item === "object" ? item.id : item
                            )
                          : null;

                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        scope_ref_id: validScopeIds,
                      }));
                    }}
                    options={
                      // selectScope === 1
                      //   ? batchData
                      //     .filter((batch) => batch.course_id === selectedCourse)
                      //     .map((batch) => ({
                      //       label: batch.label,
                      //       id: batch.id,
                      //     }))
                      selectScope === 1
                        ? batchData
                            .filter(
                              (batch) =>
                                batch.course_id === selectedCourse &&
                                selectedClass.includes(batch.class_id)
                            )
                            .map((batch) => ({
                              label: batch.label,
                              id: batch.id,
                            }))
                        : selectScope === 2
                        ? branchData.map((branch) => ({
                            label: branch.label,
                            id: branch.id,
                          }))
                        : selectScope === 3
                        ? zoneData.map((zone) => ({
                            label: zone.label,
                            id: zone.id,
                          }))
                        : selectScope === 4
                        ? cityData.map((city) => ({
                            label: city.label,
                            id: city.id,
                          }))
                        : selectScope === 5
                        ? stateData.map((state) => ({
                            label: state.label,
                            id: state.id,
                          }))
                        : []
                    }
                    placeholder={
                      selectScope === 1
                        ? "Search Batch"
                        : selectScope === 2
                        ? "Search Branch"
                        : selectScope === 3
                        ? "Search Zone"
                        : selectScope === 4
                        ? "Search City"
                        : selectScope === 5
                        ? "Search State"
                        : selectScope === 6
                        ? "Search Region"
                        : "Select an option"
                    }
                    minheight="250px"
                    Height="auto"
                    OverFlow="auto"
                    showSelectAll={true}
                    // disabled={selectScope === 7}
                    disabled={selectScope === 9 || !!selectedtestSeriesId}
                  />
                </div>
                <div className="item10">
                  <MultiSelectSearchDropdown
                    label="Student Group"
                    width="100%"
                    selected={selectedStudentGroup}
                    // setSelected={setSelectedStudentGroup}
                    setSelected={(selected) => {
                      setSelectedStudentGroup(selected);
                      setFormData((prev) => ({
                        ...prev,
                        student_group_id_list: selected, // ✅ ADD THIS
                      }));
                    }}
                    options={getFilteredStudentGroups().map((g) => ({
                      label: g.label,
                      id: g.id,
                    }))}
                    isRequired={false}
                    placeholder="Select Student Group..."
                    singleSelect={false}
                    onSearchInputChange={searchStudentGroups}
                    disabled={questionPaperType === 2}
                  />
                </div>
                <div className="item9">
                  <DropDown
                    label="Apply Pattern"
                    setSelected={(selectedOption) => {
                      setSelectedPattern(selectedOption || null);
                      const selectedPatternObj = patternsData.find(
                        (pattern) => pattern.id === selectedOption
                      );
                      if (selectedPatternObj) {
                        const { subjects, details } = selectedPatternObj;
                        const newCheckedSubjects = {};
                        const newExpandedSubjects = {};
                        const newSelectedChapters = {};
                        const newSpecialInstructions = {};
                        const newDifficultyDistributions = {};
                        const newQuestionCounts = {};
                        const newFormSubjects = [];

                        let totalQuestions = 0;

                        subjects.forEach((subj) => {
                          const subjectId = subj.subject_id;
                          const easy = subj.easy || 0;
                          const medium = subj.medium || 0;
                          const tough = subj.tough || 0;
                          const total = easy + medium + tough;
                          //  Set checkbox checked
                          newCheckedSubjects[subjectId] = true;
                          newExpandedSubjects[subjectId] = false;

                          //  Select chapters
                          newSelectedChapters[subjectId] = subj.chapters.map(
                            (ch) => ch.chapter_id
                          );

                          //  Special Instructions
                          newSpecialInstructions[subjectId] =
                            subj.special_inst || "";

                          //  Difficulty slider values
                          newDifficultyDistributions[subjectId] = {
                            firstSegment: easy,
                            secondSegment: medium,
                            calculatedValue: tough,
                          };

                          //  Set question count to easy + medium + tough
                          newQuestionCounts[subjectId] = total;
                          totalQuestions += total;

                          //  Update formData subjects array
                          newFormSubjects.push({
                            subject_id: subjectId,
                            easy,
                            medium,
                            tough,
                            special_inst: subj.special_inst || "",
                            chapters: subj.chapters || [],
                          });

                          //  Fetch chapters if not cached
                          if (!chapterData[subjectId]) {
                            fetch(
                              `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${subjectId}`
                            )
                              .then((res) => res.json())
                              .then((data) => {
                                setChapterData((prev) => ({
                                  ...prev,
                                  [subjectId]: data,
                                }));
                              });
                          }
                        });

                        //  Apply all state updates
                        setCheckedSubjects(newCheckedSubjects);
                        setExpandedSubjects(newExpandedSubjects);
                        setSelectedChapters(newSelectedChapters);
                        setSpecialInstructions(newSpecialInstructions);
                        setDifficultyDistributions(newDifficultyDistributions);
                        setTotalQuestionCount(totalQuestions);
                        setSelectedSubjects(subjects);
                        setSubjects((prevSubjects) =>
                          prevSubjects.map((subj) => {
                            const patternSubj =
                              selectedPatternObj.subjects.find(
                                (ps) => ps.subject_id === subj.subject_id
                              );
                            const isUserModified =
                              manuallyUpdatedSubjects[subj.subject_id];
                            if (patternSubj && !isUserModified) {
                              const total =
                                (patternSubj.easy || 0) +
                                (patternSubj.medium || 0) +
                                (patternSubj.tough || 0);
                              return {
                                ...subj,
                                questionCount: total,
                              };
                            }

                            return subj; // leave untouched
                          })
                        );
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          total_questions: totalQuestions,
                          ques_paper_type: details.ques_paper_type || null,
                          subjects: newFormSubjects,
                        }));
                      }
                    }}
                    options={
                      patternsData.length > 0
                        ? patternsData
                        : [{ id: "", label: "No Patterns Available" }]
                    }
                    minheight="250px"
                    Height="auto"
                    OverFlow="auto"
                    disabled={!!selectedtestSeriesId}
                  />
                </div>
                <div className="item7-ques-paper-desc-del">
                  <FormInputs
                    label="Description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="item7-ques-paper-guideline-del">
                  <label>Guideline</label>
                  <textarea
                    placeholder="Write your guidelines here..."
                    value={formData.guidelines} // Controlled component
                    onChange={(e) =>
                      setFormData({ ...formData, guidelines: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* SUBJECTS Section */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>SUBJECTS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordion}>
            {isOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpen && (
          <div className="accordion-content">
            <div>
              <table className="table-tc-create-test" style={{ opacity: 0.8 }}>
                <thead>
                  <tr>
                    <td>Subject/Chapter</td>
                    <td>
                      Ques Count
                      <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                    </td>
                    <td>Difficulty Level</td>
                    <td>
                      Assign Creators
                      <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                    </td>
                    <td>Assign Reviewer</td>
                    {/* <td> Assign Reviewer {questionPaperType === 2 && ( <span style={{ color: "red", marginLeft: "5px" }}>*</span> )} </td>  */}
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(subjects) && subjects.length > 0 ? (
                    subjects.map((subject) => {
                      const isChecked =
                        checkedSubjects[subject.subject_id] || false;
                      return (
                        <React.Fragment key={subject.subject_id}>
                          <tr
                            style={{
                              height: "62px",
                              opacity: isChecked ? 1 : 0.8,
                              borderBottom: expandedSubjects[subject.subject_id]
                                ? ""
                                : "1px solid #d6d6d6",
                            }}
                          >
                            <td style={{ width: "12%" }}>
                              <input
                                type="checkbox"
                                disabled={!!selectedtestSeriesId}
                                className="delete-question-checkbox-dqc"
                                checked={isChecked}
                                onChange={() =>
                                  handleSubjectCheck(subject.subject_id)
                                }
                                style={{ opacity: 1 }}
                              />
                              <span
                                style={{
                                  marginRight: "6px",
                                  cursor: isChecked ? "pointer" : "not-allowed",
                                  fontWeight: "bold",
                                  opacity: isChecked ? 1 : 0.5,
                                }}
                                onClick={() =>
                                  toggleExpandSubject(subject.subject_id)
                                }
                              >
                                {expandedSubjects[subject.subject_id]
                                  ? "−"
                                  : "+"}
                                {/* {(selectedChapters[subject.subject_id]
                                  ?.length || 0) === 0
                                  ? "+"
                                  : expandedSubjects[subject.subject_id]
                                    ? "−"
                                    : "+"} */}
                              </span>
                              {subject.subject_name}
                            </td>
                            <td style={{ width: "7%" }}>
                              <input
                                type="text"
                                className="input-details-nts-cr-test"
                                maxLength={3}
                                value={
                                  isChecked ? subject.questionCount || "" : ""
                                }
                                onChange={(e) =>
                                  handleQuestionCountChange(
                                    subject.subject_id,
                                    e.target.value
                                  )
                                }
                                style={{ opacity: isChecked ? 1 : 0.8 }}
                                // readOnly={!isChecked}
                                readOnly={!isChecked || !!selectedtestSeriesId}
                              />
                            </td>
                            <td style={{ width: "30%" }}>
                              <MultiProgress
                                total={
                                  isChecked
                                    ? parseInt(subject.questionCount, 10) || 0
                                    : 0
                                }
                                onSliderChange={(values) =>
                                  handleSliderChange(subject.subject_id, values)
                                }
                                defaultValues={
                                  difficultyDistributions[subject.subject_id]
                                }
                              />
                            </td>
                            <td style={{ width: "12%", verticalAlign: "top" }}>
                              <div className="input-wrapper-column">
                                <div className="input-wrapper-top">
                                  <FacultySelector
                                    isMultiSelect={true}
                                    userId={userId}
                                    selectedSubjectId={subjects}
                                    isChecked={isChecked}
                                    onSelectionChange={(selectedFaculties) => {
                                      setSelectedCreatorsBySubject((prev) => ({
                                        ...prev,
                                        [subject.subject_id]: selectedFaculties,
                                      }));
                                    }}
                                    excludeUserIds={(
                                      selectedReviewersBySubject[
                                        subject.subject_id
                                      ] || []
                                    ).map((f) => f.user_id)}
                                  />
                                  <img
                                    src={NotesIcon}
                                    alt="Notes Icon"
                                    className="outside-icon-notes"
                                    onClick={() =>
                                      toggleNotesInput(subject.subject_id)
                                    }
                                    style={{
                                      cursor: isChecked
                                        ? "pointer"
                                        : "not-allowed",
                                      opacity: isChecked ? 1 : 0.5,
                                    }}
                                  />
                                </div>

                                {/** Only render input if needed */}
                                {openNotes[subject.subject_id] && isChecked && (
                                  <input
                                    type="text"
                                    className="assign-notes-input"
                                    placeholder="Add a note..."
                                    value={
                                      specialInstructions[subject.subject_id] ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      handleSpecialInstructionChange(
                                        subject.subject_id,
                                        e.target.value
                                      )
                                    }
                                    disabled={!isChecked}
                                  />
                                )}
                              </div>
                            </td>
                            <td style={{ width: "18%" }}>
                              <div
                                className="input-wrapper"
                                style={{
                                  opacity: isChecked ? 1 : 0.8,
                                  position: "relative",
                                }}
                              >
                                <FacultySelector
                                  isMultiSelect={false}
                                  userId={userId}
                                  isChecked={isChecked}
                                  selectedSubjectId={subjects}
                                  onSelectionChange={(selectedFaculties) => {
                                    setSelectedReviewersBySubject((prev) => ({
                                      ...prev,
                                      [subject.subject_id]: selectedFaculties,
                                    }));
                                  }}
                                  style={{ opacity: isChecked ? 1 : 0.8 }}
                                  excludeUserIds={(
                                    selectedCreatorsBySubject[
                                      subject.subject_id
                                    ] || []
                                  ).map((f) => f.user_id)}
                                />
                              </div>
                            </td>
                          </tr>
                          {expandedSubjects[subject.subject_id] && (
                            // isChecked &&
                            <tr style={{ borderBottom: "1px solid  #d6d6d6" }}>
                              <td colSpan="5">
                                <div className="chapter-list-create-test">
                                  <ul>
                                    <li style={{ marginBottom: "14px" }}>
                                      <input
                                        type="checkbox"
                                        ref={(el) => {
                                          if (el) {
                                            const total =
                                              chapterData[subject.subject_id]
                                                ?.length || 0;
                                            const selected =
                                              selectedChapters[
                                                subject.subject_id
                                              ]?.length || 0;
                                            el.indeterminate =
                                              selected > 0 && selected < total;
                                          }
                                        }}
                                        className={
                                          selectedChapters[subject.subject_id]
                                            ?.length ===
                                          chapterData[subject.subject_id]
                                            ?.length
                                            ? "delete-question-checkbox-dqc"
                                            : selectedChapters[
                                                subject.subject_id
                                              ]?.length > 0
                                            ? "expend-chapt-sub-check-box indeterminate"
                                            : "expend-chapt-sub-check-box"
                                        }
                                        onChange={() =>
                                          handleSelectAllChapters(
                                            subject.subject_id
                                          )
                                        }
                                        checked={
                                          selectedChapters[subject.subject_id]
                                            ?.length ===
                                          chapterData[subject.subject_id]
                                            ?.length
                                        }
                                      />
                                      Chapters
                                    </li>
                                    {Array.isArray(
                                      chapterData[subject.subject_id]
                                    ) &&
                                    chapterData[subject.subject_id].length >
                                      0 ? (
                                      chapterData[subject.subject_id].map(
                                        (chapter) => (
                                          <li
                                            key={chapter.chapter_id}
                                            className="chapter-item-cr-ts"
                                          >
                                            <input
                                              type="checkbox"
                                              className="delete-question-checkbox-dqc"
                                              checked={
                                                selectedChapters[
                                                  subject.subject_id
                                                ]?.includes(
                                                  chapter.chapter_id
                                                ) || false
                                              }
                                              onChange={() =>
                                                handleChapterCheck(
                                                  subject.subject_id,
                                                  chapter.chapter_id
                                                )
                                              }
                                            />
                                            {chapter.chapter_name}
                                          </li>
                                        )
                                      )
                                    ) : (
                                      <div className="chapter-details">
                                        No chapters available
                                      </div>
                                    )}
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center" }}>
                        No subjects available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="total-question-count-cr-test">
              <span>Total Questions: </span> {totalQuestionCount}
            </div>
          </div>
        )}
      </div>
      {showPatternPopup && (
        <div className="popup-overlay-template-layout">
          <div className="popup-box-template-layout">
            <h3>Save as Pattern</h3>
            <div className="input-wrapper-apply-pattern">
              <label>Pattern Name</label>
              <input
                type="text"
                value={patternName}
                onChange={(e) => {
                  const value = e.target.value;
                  setPatternName(value);
                  if (patternNameError && value.trim()) {
                    setPatternNameError(false);
                  }
                }}
                className={
                  patternNameError ? "input-box error-border" : "input-box"
                }
                placeholder="Enter pattern name"
              />
              <span className="error-text-pattern">
                {patternNameError ? "Pattern name is required." : ""}
              </span>
            </div>

            <div className="input-wrapper-apply-pattern">
              <label>Pattern Description</label>
              <input
                type="text"
                value={patternDesc}
                onChange={(e) => {
                  const value = e.target.value;
                  setPatternDesc(value);
                  if (patternDescError && value.trim()) {
                    setPatternDescError(false);
                  }
                }}
                className={
                  patternDescError ? "input-box error-border" : "input-box"
                }
                placeholder="Enter description"
              />
              <span className="error-text-pattern">
                {patternDescError ? "Pattern description is required." : ""}
              </span>
            </div>
            {patternPopupError && (
              <div
                className="error-text-pattern"
                style={{ color: "red", marginBottom: "20px" }}
              >
                {patternPopupError}
              </div>
            )}
            <div className="popup-actions-template-layout">
              <button
                className="testreportcard-cancel-btn"
                style={{ marginRight: "20px" }}
                onClick={() => {
                  setShowPatternPopup(false);
                  window.location.reload();
                }}
              >
                CANCEL
              </button>
              <button
                className="testreportcard-cancel-btn"
                style={{ width: "120px", marginRight: "0px" }}
                onClick={handleCreatePattern}
              >
                SAVE PATTERN
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreateQuesPaper;

{
  /* <DropDown label="Question Paper Type" selected={questionPaperType}
                    setSelected={(selectedOption) => { setQuestionPaperType(selectedOption); setFormData({ ...formData, ques_paper_type: selectedOption || null, }); }}
                    options={[ { id: 1, label: "DPP" }, { id: 2, label: "Test" }, ]}
                    isRequired={true}
                  /> */
}
{
  /* <DropDown
                      label="Question Paper Type"
                      selected={questionPaperType}
                      setSelected={(selectedOption) => {
                        setQuestionPaperType(selectedOption);

                        // Clear test series selection on DPP
                        if (selectedOption === 1) {
                          setSelectedTestSeriesID(null);
                          setFormData((prev) => ({
                            ...prev,
                            test_series_id: null,
                          }));
                          setDropdownKey((prev) => prev + 1); // 🔁 Force re-render
                        } else {
                          setFormData((prev) => ({
                            ...prev,
                            ques_paper_type: selectedOption || null,
                          }));
                        }
                      }}
                      options={[
                        { id: 1, label: "DPP" },
                        { id: 2, label: "Test" },
                      ]}
                      isRequired={true}
                    /> */
}

// const handleQuestionCountChange = (subjectId, value) => {
//   if (/^\d*$/.test(value)) {
//     const parsedValue = parseInt(value || 0, 10);

//     // Mark subject as manually updated
//     setManuallyUpdatedSubjects((prev) => ({
//       ...prev,
//       [subjectId]: true,
//     }));

//     // Update the subject state
//     setSubjects((prevSubjects) =>
//       prevSubjects.map((subject) =>
//         subject.subject_id === subjectId
//           ? { ...subject, questionCount: parsedValue }
//           : subject
//       )
//     );

//     // Update total
//     const newTotal = subjects.reduce((acc, subject) => {
//       const count =
//         subject.subject_id === subjectId
//           ? parsedValue
//           : parseInt(subject.questionCount || 0, 10);
//       return acc + count;
//     }, 0);
//     setTotalQuestionCount(newTotal);
//   }
// };

// const handleSliderChange = (subjectId, values) => {
//   setDifficultyDistributions((prev) => ({
//     ...prev,
//     [subjectId]: values, // Store firstSegment, secondSegment, calculatedValue
//   }));

//   // console.log(`easy: ${subjectId}`, values.firstSegment);
//   // console.log(`medium: ${subjectId}`, values.secondSegment);
//   // console.log(`tough: ${subjectId}`, values.calculatedValue);
// };

{
  /* <td style={{ width: "12%" }}>
                              <div className="input-wrapper" style={{ opacity: isChecked ? 1 : 0.8, position: "relative", }} >
                                <FacultySelector
                                  isMultiSelect={true}
                                  userId={userId}
                                  selectedSubjectId={subjects}
                                  isChecked={isChecked} //  Pass isChecked to FacultySelector
                                  onSelectionChange={(selectedFaculties) => {
                                    setSelectedCreatorsBySubject((prev) => ({
                                      ...prev,
                                      [subject.subject_id]: selectedFaculties,
                                    }));
                                  }}
                                  style={{ opacity: isChecked ? 1 : 0.8 }} //  Change opacity when unchecked
                                />
                                <img src={NotesIcon} alt="Notes Icon" className="outside-icon-notes"
                                  onClick={() => toggleNotesInput(subject.subject_id) }
                                  style={{ cursor: isChecked ? "pointer" : "not-allowed", opacity: isChecked ? 1 : 0.5, }}
                                />
                              </div>
                              {openNotes[subject.subject_id] && isChecked && (
                                <input
                                  type="text"
                                  className="assign-notes-input"
                                  placeholder="Add a note..."
                                  value={ specialInstructions[subject.subject_id] || "" } 
                                  onChange={(e) => handleSpecialInstructionChange( subject.subject_id, e.target.value ) }
                                  disabled={!isChecked}
                                />
                              )}
                            </td> */
}

// const handleSelectAllChapters = (subjectId) => {
//   const allSelected =
//     selectedChapters[subjectId]?.length === chapterData[subjectId]?.length;

//   const updatedChapters = allSelected
//     ? []
//     : chapterData[subjectId].map((ch) => ch.chapter_id);

//   setSelectedChapters((prevChapters) => ({
//     ...prevChapters,
//     [subjectId]: updatedChapters,
//   }));

//   // setCheckedSubjects((prev) => ({
//   //   ...prev,
//   //   [subjectId]: !allSelected, // ❗️Uncheck subject if all are being cleared
//   // }));

//   setFormData((prevFormData) => {
//     const filteredSubjects = prevFormData.subjects.filter(
//       (s) => s.subject_id !== subjectId
//     );

//     if (allSelected) {
//       // Removing all
//       return {
//         ...prevFormData,
//         subjects: filteredSubjects,
//       };
//     } else {
//       // Adding back
//       return {
//         ...prevFormData,
//         subjects: [
//           ...filteredSubjects,
//           {
//             subject_id: subjectId,
//             easy: difficultyDistributions[subjectId]?.firstSegment || 0,
//             medium: difficultyDistributions[subjectId]?.secondSegment || 0,
//             tough: difficultyDistributions[subjectId]?.calculatedValue || 0,
//             special_inst: specialInstructions[subjectId] || "",
//             chapters: updatedChapters.map((id) => ({ chapter_id: id })),
//           },
//         ],
//       };
//     }
//   });
// }

// const handleChapterCheck = (subjectId, chapterId) => {
//   setSelectedChapters((prevChapters) => {
//     const isSelected = prevChapters[subjectId]?.includes(chapterId);
//     const updatedChapters = isSelected
//       ? prevChapters[subjectId].filter((id) => id !== chapterId)
//       : [...(prevChapters[subjectId] || []), chapterId];
//     return { ...prevChapters, [subjectId]: updatedChapters };
//   });
// };

// const handleSubjectCheck = (subjectId) => {
//   setCheckedSubjects((prev) => {
//     const isChecked = !prev[subjectId];

//     if (isChecked) {
//       //  Automatically select all chapters when subject is checked
//       const chapters = chapterData[subjectId] || [];

//       setSelectedChapters((prevChapters) => ({
//         ...prevChapters,
//         [subjectId]: chapters.map((ch) => ch.chapter_id),
//       }));

//       //  Update formData with selected chapters
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         subjects: [
//           ...prevFormData.subjects.filter((s) => s.subject_id !== subjectId),
//           {
//             subject_id: subjectId,
//             easy: 0,
//             medium: 0,
//             tough: 0,
//             special_inst: "",
//             chapters: chapters.map((ch) => ({ chapter_id: ch.chapter_id })),
//           },
//         ],
//       }));
//     } else {
//       // If unchecked, remove from selectedChapters and formData
//       setSelectedChapters((prevChapters) => ({
//         ...prevChapters,
//         [subjectId]: [],
//       }));

//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         subjects: prevFormData.subjects.filter(
//           (s) => s.subject_id !== subjectId
//         ),
//       }));
//     }

//     return { ...prev, [subjectId]: isChecked };
//   });

//   if (!chapterData[subjectId]) {
//     // Fetch chapters if not already fetched
//     fetch(
//       `${FULL_API_BASE_URL}/get-chapters-by-subject/?subject_id=${subjectId}`
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         setChapterData((prev) => ({ ...prev, [subjectId]: data }));

//         //  Automatically select all chapters when they are fetched
//         setSelectedChapters((prevChapters) => ({
//           ...prevChapters,
//           [subjectId]: data.map((ch) => ch.chapter_id),
//         }));

//         setFormData((prevFormData) => ({
//           ...prevFormData,
//           subjects: [
//             ...prevFormData.subjects.filter(
//               (s) => s.subject_id !== subjectId
//             ),
//             {
//               subject_id: subjectId,
//               easy: 0,
//               medium: 0,
//               tough: 0,
//               special_inst: "",
//               chapters: data.map((ch) => ({ chapter_id: ch.chapter_id })),
//             },
//           ],
//         }));
//       })
//       .catch((error) => console.error("Error fetching chapters:", error));
//   }
// };

{
  /* <SelectedDropdownValues
                    label="Scope"
                    selected={selectScope} 
                    setSelected={(selectedOption) => {
                      setSelectedScope(selectedOption || null);
                      setFormData({
                        ...formData,
                        ques_paper_scope_id: selectedOption || null,
                      });
                    }}
                    options={
                      Array.isArray(scopeData)
                        ? scopeData.map((scope) => ({
                          label: scope.ques_paper_scope_desc,
                          id: scope.ques_paper_scope_id,
                        }))
                        : []
                    }
                    disabled={!!selectedtestSeriesId}
                  /> */
}

{
  /* <DropDown
                    label="Course"
                    setSelected={(selectedOption) => {
                      setSelectedCourse(selectedOption || null);
                      //  Update formData with course_id & courses array
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        course_id: selectedOption || null,
                        courses: selectedOption
                          ? [{ course_id: selectedOption }]
                          : [], // Ensures array format
                      }));
                      setSubjects([]); //  Reset subjects before fetching new data
                      setCheckedSubjects({}); //  Clear selected subjects
                      setExpandedSubjects({}); //  Close expanded subjects
                    }}
                    options={
                      Array.isArray(coursesdata)
                        ? coursesdata.map((course) => ({
                          label: course.course_name,
                          id: course.course_id,
                        }))
                        : []
                    }
                    isRequired={true}
                  /> */
}

{
  /* <DropDown label="Test Series" 
                  key={dropdownKey} 
                  selected={selectedtestSeriesId}
                    setSelected={(selectedOption) => {
                      setSelectedTestSeriesID(selectedOption);
                      setFormData({ ...formData, test_series_id: selectedOption || null, }); }}
                    options={testSeriesOptions}
                    isRequired={false}
                    disabled={questionPaperType === 1} // Disable if "DPP" is selected
                  /> */
}
// ✅ Auto-select ScopeRef based on scope_id
// switch (fullTS.scope_id) {
//   case 1:
//     setSelectedBatch(fullTS.scope_ref_ids);
//     break;
//   case 2:
//     setSelectedBranch(fullTS.scope_ref_ids);
//     break;
//   case 3:
//     setSelectedZone(fullTS.scope_ref_ids);
//     break;
//   case 4:
//     setSelectedCities(fullTS.scope_ref_ids);
//     break;
//   case 5:
//     setSelectedStates(fullTS.scope_ref_ids);
//     break;
//   case 6:
//     setSelectedRegion(fullTS.scope_ref_ids);
//     break;
//   default:
//     break;
// }

// (fullTS.subject_section || []).forEach((subj) => {
//   checked[subj.subject_id] = true;
//   const count = subj.mandatory_ques_cnt || 0;
//   questionCounts[subj.subject_id] = count;
//   const easy = Math.floor(count / 3);
//   const medium = Math.floor(count / 3);
//   const tough = count - (easy + medium);
//   difficultyMap[subj.subject_id] = {
//     firstSegment: easy,
//     secondSegment: medium,
//     calculatedValue: tough,
//   };
//   totalCount += count;

//   formSubjects.push({
//     subject_id: subj.subject_id,
//     easy,
//     medium,
//     tough,
//     special_inst: subj.ms_desc || "",
//     chapters: [], // You can populate chapter data later if needed
//   });
// });
